import React from "react"
import Index from "../Index"
import { contentLayout, modules } from "../../config/pages"
import { useUser } from "../../contexts/UserContext"
import Forbidden from "../Forbidden"

function ViewCycle (){
  const {user} = useUser()
  let view = contentLayout[modules.ViewCycle]
  if(user.permissions.views.length && !user.permissions.views.join().includes(modules.ViewCycle.toLowerCase())){
    view = Forbidden
  }
  return(
  <Index content={view} module={modules.ViewCycle}></Index>
 )
}

export default ViewCycle
